import axios from '../config/axios';

const API_BASE = '/testimonials';

export const testimonialService = {
  // Get all testimonials with optional base64 images
  getAllTestimonials: (page = 1, perPage = 20, activeOnly = true, includeImage = false) => {
    const params = {
      page,
      per_page: perPage,
      active_only: activeOnly,
      include_image: includeImage
    };
    return axios.get(API_BASE, { params });
  },

  // Get single testimonial (always includes base64 image if available)
  getTestimonial: (testimonialId) => {
    return axios.get(`${API_BASE}/${testimonialId}`);
  },

  // Create testimonial
  createTestimonial: (formData) => {
    return axios.post(API_BASE, formData, {
      headers: { 'Content-Type': undefined }
    });
  },

  // Update testimonial
  updateTestimonial: (testimonialId, formData) => {
    return axios.put(`${API_BASE}/${testimonialId}`, formData, {
      headers: { 'Content-Type': undefined }
    });
  },

  // Delete testimonial
  deleteTestimonial: (testimonialId) => {
    return axios.delete(`${API_BASE}/${testimonialId}`);
  },

  // Toggle active status
  toggleActive: (testimonialId) => {
    return axios.post(`${API_BASE}/${testimonialId}/toggle-active`);
  },

  // Get testimonial image (as file/blob - for direct image URLs if needed)
  getImage: (testimonialId) => {
    return axios.get(`${API_BASE}/${testimonialId}/image`, { responseType: 'blob' });
  },

  // Get statistics
  getStatistics: () => {
    return axios.get(`${API_BASE}/statistics`);
  },

  // Get featured testimonials (includes base64 images)
  getFeatured: (limit = 6) => {
    return axios.get(`${API_BASE}/featured`, { params: { limit } });
  }
};
